module.exports = __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 170
// module chunks = 0